import type React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { type NavigateFunction, useNavigate } from 'react-router';

import type { Dispatch, State } from '../../types';
import { getGeofences as fetchGeofences } from '../actions/geofenceActions';
import { fetchPOIs } from '../actions/poiActions';
import { Routing } from '../app/Routing';
import { mapGeofenceToTableObject } from '../mapper/GeofenceMapper';
import { mapPOIToTableObject } from '../mapper/PoiMapper';
import { AllowedListAction } from '../reducers/geofenceReducer';
import {
    getGeofences,
    getIsGeofencesLoading,
    getIsPoisLoading,
    getPois,
    isGeofenceActionAllowed,
} from '../reducers/selectors';
import { POIAndGeofenceTable } from './POIAndGeofenceTable';

export const withRouter =
    <ComponentProps,>(Component: React.FunctionComponent<ComponentProps>) =>
    (props: ComponentProps) => {
        const navigate = useNavigate();
        return <Component {...props} navigate={navigate} />;
    };

export const concatenatePoisAndGeofencesToOldReadModel = (fetchedPois: any, fetchedGeofences: any) => {
    const mappedPois = fetchedPois.map((poi: any) => mapPOIToTableObject(poi));
    const mappedGeofences = fetchedGeofences.map((geofence: any) => mapGeofenceToTableObject(geofence));
    return mappedPois.concat(mappedGeofences);
};

export const mapStateToProps = (state: State) => {
    const pois = getPois(state);
    const geofences = getGeofences(state);
    return {
        isPoisLoading: getIsPoisLoading(state),
        isGeofencesLoading: getIsGeofencesLoading(state),
        listOfPOIsAndGeofences: concatenatePoisAndGeofencesToOldReadModel(pois, geofences),
        allowedToCreateGeofence: isGeofenceActionAllowed(state, AllowedListAction.GEOFENCE_CREATE),
    };
};

export const mapDispatchToProps = (dispatch: Dispatch) => ({
    geofenceEditHandler: (geofenceId: string, navigate: NavigateFunction) =>
        navigate(Routing.geofenceEdit.replace(':id', geofenceId)),
    refreshPoiTableData: () => {
        dispatch(fetchPOIs());
        dispatch(fetchGeofences());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(POIAndGeofenceTable)));
